import { getVuelosProveedorAll, getVuelosProveedorID, newVueloProveedor, putVueloProveedor } from "../services/fligthService"
import { getCircuitosIdProveedorTerrestre, getProveedorTerrestreLista, getTerrestresByIdVuelo, newAereoCircuito } from "../services/packageService"
import { getProveedoresAereosCatalogo } from "../services/supplierService"
import { FormatoFecha } from "../utils/FormatFecha"

//TODO: Este documento pertenece al nuevo flujo de paquetes mayoristas
const dataInicial = {
    arrayVuelos: [],
    catalogoProvAereo: [],
    exito: 0,
    pagina: 0,
    registros: 10,
    filtroProveedor: "NA",
    total: 0,
    openModalCircuitoVuelo: false,
    vueloTarget: {},
    listaPaqueteTerrestres: [],
    listaVuelosCircuitos: []
}

const OBTENER_PROV_VUELO_ALL_ACTION = "OBTENER_PROV_VUELO_ALL_ACTION"
const OBTENER_PROV_VUELO_PAGINA_ACTION = "OBTENER_PROV_VUELO_PAGINA_ACTION"
const OBTENER_PROV_VUELO_REGISTROS_ACTION = "OBTENER_PROV_VUELO_REGISTROS_ACTION"
const OBTENER_PROV_VUELO_PROVEDOR_ACTION = "OBTENER_PROV_VUELO_PROVEDOR_ACTION"
const NUEVO_PROV_VUELO_ACTION = "NUEVO_PROV_VUELO_ACTION"
const ACTUALIZA_PROV_VUELO_ACTION = "ACTUALIZA_PROV_VUELO_ACTION"
const OBTENER_PROV_AEREO_CATALOGO_ACTION = "OBTENER_PROV_AEREO_CATALOGO_ACTION"
//TODO unir vuelos con cirucitos
const NUEVO_CIRCUITO_VUELO_ACTION = "NUEVO_CIRCUITO_VUELO_ACTION"
const OPEN_CIRCUITO_VUELO_ACTION = "OPEN_CIRCUITO_VUELO_ACTION"
const OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES = "OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES"
const OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION = "OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION"
export default function vueloProveedorReducer(state = dataInicial, action) {
    if (action.type === OBTENER_PROV_VUELO_ALL_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total }
    if (action.type === OBTENER_PROV_VUELO_PAGINA_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, pagina: action.payload.pagina }
    if (action.type === OBTENER_PROV_VUELO_REGISTROS_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, registros: action.payload.registros }
    if (action.type === OBTENER_PROV_VUELO_PROVEDOR_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, filtroProveedor: action.payload.filtroProveedor }
    if (action.type === OBTENER_PROV_AEREO_CATALOGO_ACTION)
        return { ...state, catalogoProvAereo: action.payload.catalogoProvAereo }
    if (action.type === NUEVO_PROV_VUELO_ACTION || action.type === ACTUALIZA_PROV_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    // TODO Unir vuelo con cirucuto
    if (action.type === NUEVO_CIRCUITO_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    if (action.type === OPEN_CIRCUITO_VUELO_ACTION)
        return { ...state, openModalCircuitoVuelo: action.payload.openModalCircuitoVuelo, vueloTarget: action.payload.vueloTarget }
    if (action.type === OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES)
        return { ...state, listaPaqueteTerrestres: action.payload.listaPaqueteTerrestres }
    if (action.type === OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION)
        return { ...state, listaVuelosCircuitos: action.payload.listaVuelosCircuitos}
    return { ...state }
}
export const obtenerVuelosProveedorAllAction = () => async (dispatch, getState) => {
    const { pagina, registros, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ IdProveedor: filtroProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_ALL_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
            }
        })
        return Response
    })
}
export const obtenerVuelosProveedorPaginaAction = (pagina) => async (dispatch, getState) => {
    const { registros, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ IdProveedor: filtroProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_PAGINA_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                pagina: pagina
            }
        })
        return Response
    })
}

export const obtenerVuelosProveedorRegistrosAction = (registros) => async (dispatch, getState) => {
    const { pagina, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ IdProveedor: filtroProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_REGISTROS_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                registros: registros
            }
        })
        return Response
    })
}

export const obtenerVuelosProveedorFiltroProveedorAction = ({ idProveedor }) => async (dispatch, getState) => {
    const { pagina, registros } = dataInicial
    return await getVuelosProveedorAll({ IdProveedor: idProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_PROVEDOR_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                registros: registros,
                pagina: pagina,
                filtroProveedor: idProveedor
            }
        })
        return Response
    })
}

export const obtenerCatalogoProveedorAereoAction = () => async (dispatch) => {
    return await getProveedoresAereosCatalogo().then(Response => {
        dispatch({
            type: OBTENER_PROV_AEREO_CATALOGO_ACTION,
            payload: {
                catalogoProvAereo: Response
            }
        })
    })
}

export const crearVueloProveedorAction = ({ ClaveVuelo, Disponibilidad, EsRedondo, FechaSalida, IdDestino, IdMoneda, IdOrigen, IdProveedor, PrecioNeto, VueloRedondo }) => async (dispatch) => {
    let vueloRedondo = { ...VueloRedondo, FechaSalida: FormatoFecha({ date: VueloRedondo?.FechaSalida, formato: "yyyy-MM-dd HH:MM" }) }
    return await newVueloProveedor({
        ClaveVuelo,
        Disponibilidad,
        EsRedondo,
        FechaSalida: FormatoFecha({ date: FechaSalida, formato: "yyyy-MM-dd HH:MM" }),
        IdDestino,
        IdMoneda,
        IdOrigen,
        IdProveedor,
        PrecioNeto,
        VueloRedondo: vueloRedondo
    }).then(Response => {
        dispatch({
            type: NUEVO_PROV_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
// export const actulizaTerrestreAction = ({ IdVueloProveedor }) => async (dispatch) => {
//     return await putVueloProveedor({ IdVueloProveedor }).then(Response => {
//         dispatch({
//             type: ACTUALIZA_PROV_VUELO_ACTION,
//             payload: {
//                 exito: 1
//             }
//         })
//         return Response
//     }).catch(Error => {
//         return Error
//     })
// }

//TODO MEtodos par aunir vuelo con el cirucuito
export const crearVueloCircuito = ({ IdPaqueteCircuito, IdVueloProveedor }) => async (dispatch) => {
    return await newAereoCircuito({ IdPaqueteCircuito, IdVueloProveedor }).then(Response => {
        dispatch({
            type: NUEVO_CIRCUITO_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openCircuitoVueloAction = ({ vuelo }) => (dispatch) => {
    dispatch({
        type: OPEN_CIRCUITO_VUELO_ACTION,
        payload: {
            openModalCircuitoVuelo: true,
            vueloTarget: vuelo
        }
    })
}
export const closeCircuitoVueloAction = () => (dispatch) => {
    const { openModalCircuitoVuelo, vueloTarget } = dataInicial
    dispatch({
        type: OPEN_CIRCUITO_VUELO_ACTION,
        payload: {
            openModalCircuitoVuelo: openModalCircuitoVuelo,
            vueloTarget: vueloTarget
        }
    })
}
export const obtenerTerrestreAllListaAction = () => async (dispatch) => {
    return await getProveedorTerrestreLista().then(Response => {
        dispatch({
            type: OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES,
            payload: {
                listaPaqueteTerrestres: Response
            }
        })
        return Response
    })
}
export const obtenerCircuitoVueloAction = ({IdProveedor}) => async (dispatch) => {
    return await getTerrestresByIdVuelo({IdVueloProveedor: IdProveedor, Pagina: 1, Registros: 100}).then(Response => {
        dispatch({
            type: OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION,
            payload: {
                listaVuelosCircuitos: Response.LPaqueteProveedorTerrestre
            }
        })
        return Response
    })
}